export default "__VITE_ASSET__069f8f3a__"